'use strict';
/*
    Handles focus on search unit on small screens
*/
namespace TR {

    class ErrorFocusHandler {

        constructor (
            private $scope,
            private $element,
            private $window
        ) {
            $scope.$on('flash:error', (ev, msg) => {
                if (msg) {
                   const header = $('#navbarcont');
                   if ( header ) {
                       const targetHeight = $element.offset().top - header.outerHeight();
                       if ($window.scrollY > targetHeight) {
                           $window.scrollTo(0, targetHeight);
                       }
                   }
               }
            });
        }

    }

    angular
        .module('TR')
        .directive('errorFocusHandler', (): ng.IDirective => {
            return {
                restrict: 'A',
                controller: ErrorFocusHandler,
                controllerAs: 'ef',
            };
        });
}
